const init = () => {};
document.addEventListener( 'DOMContentLoaded', function () {
	const mainNav = document.getElementById( 'main-nav' );
	const menuToggle = document.getElementById( 'menu-toggle' );
	menuToggle &&
		menuToggle.addEventListener( 'click', function (event) {
			if ( mainNav.classList.contains( 'active' ) ) {
				mainNav.classList.remove( 'active' );
				this.setAttribute( 'aria-expanded', 'false' );
			} else {
				mainNav.classList.add( 'active' );
				this.setAttribute( 'aria-expanded', 'true' );
			}
		} );
} );
// Exports
export { init };
